module.exports = __webpack_public_path__ + "media/mi.7f9e4860.mp4";